<template>
  <div id="home-route">
    <div class="weather-widget-container">
      <open-weather-widget 
        api-key="46d1179af8fab8ec6d893553fbe8f031"
      />
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import OpenWeatherWidget from 'vue-open-weather-widget'
import 'vue-open-weather-widget/dist/vue-open-weather-widget.css'

const firebaseConfig = {
  apiKey: 'AIzaSyDYBK77mn1V1wM2d1pYUHi94ZHBS3cguTY',
  authDomain: 'vue-open-weather-widget.firebaseapp.com',
  projectId: 'vue-open-weather-widget',
  storageBucket: 'vue-open-weather-widget.appspot.com',
  messagingSenderId: '1070683977546',
  appId: '1:1070683977546:web:238dc8527ae623dbfab3b3'
}
firebase.initializeApp(firebaseConfig)

export default {
  name: 'Home',
  components: {
    OpenWeatherWidget
  }
}
</script>

<style lang="scss">
:root {
  --bg-color-1: rgb(233, 233, 239);
  --scrollbar-color: rgba(0, 0, 0, 0.1);
}

#home-route {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--bg-color-1);
}

#app .weather-widget-container {
  width: 320px;
  height: 380px;
  border-radius: 12px;
  box-shadow: 
    0px 0px 2px 4px rgba(255, 255, 255, 0.1),
    -12px -12px 32px rgba(255, 255, 255, 0.5),
    12px 12px 32px rgba(0, 0, 0, 0.1);
}

#app .open-weather-widget {
  color: #616161;
  border-radius: 12px;
  background-color: var(--bg-color-1);
  &__input-element {
    & label {
      background-color: var(--bg-color-1);
    }
  }
  &__sortable-list {
    &__item {
      padding: 12px;
      margin: 16px 0;
      background-color: var(--bg-color-1);
      border-radius: 4px;
      border: none;
      box-shadow: 
        -2px -2px 8px rgba(255,255,255,0.6), 
        2px 2px 8px rgba(0,0,0,0.1);
    }
  }
  &__content-area {
    &__geo-location-denied-placeholder {
      background-color: var(--bg-color-1);
    }
  }
}

#app .open-weather-widget:not([view='main']) {
  transition: all 0.5s;
  box-shadow: 
    -4px -4px 16px rgba(255, 255, 255, 0.6),
    4px 4px 16px rgba(0, 0, 0, 0.1);
  #open-weather-widget {
    &__settings-view {
    transition: all 0.2s;
    box-shadow: 
      -41px -40px 16px -38px rgba(255,255,255,0.5) inset,
      41px 40px 16px -42px rgba(0,0,0,0.1) inset;
    }
  }
}

#app #open-weather-widget {
  &__loading-screen {
    background-color: var(--bg-color-1);
  }
}

#app #open-weather-widget__settings-view {
  mask: linear-gradient(to top, transparent 0%, black 15%);
}

body, 
html {
  &::-webkit-scrollbar {
    display: none;
  }
}

#app .open-weather-widget__location-suggestions-list, 
#app #open-weather-widget__settings-view .open-weather-widget__content-area {
  overflow: overlay;
  &::-webkit-scrollbar {
    display: none;
  }
  &:hover::-webkit-scrollbar {
    width: 16px;
    display: block;
  }
  &::-webkit-scrollbar-thumb:vertical,
  &::-webkit-scrollbar-thumb:horizontal {
    background-color: var(--scrollbar-color);
    overflow: overlay;
    min-height: 50px;
    background-clip: padding-box;
    border: 6px solid transparent;
  }
  &::-webkit-scrollbar-track:vertical,
  &::-webkit-scrollbar-track:horizontal {
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb:vertical,
  &::-webkit-scrollbar-thumb:horizontal {
    background-color: transparent;
  }
  &:hover::-webkit-scrollbar-thumb:vertical,
  &:hover::-webkit-scrollbar-thumb:horizontal {
    background-color: var(--scrollbar-color);
  }
  &::-webkit-scrollbar-thumb:vertical:hover,
  &::-webkit-scrollbar-thumb:horizontal:hover {
    background-color: var(--scrollbar-color);
    border: 1px solid transparent
  }
  &::-webkit-scrollbar-thumb:vertical:active,
  &::-webkit-scrollbar-thumb:horizontal:active {
    background-color: var(--scrollbar-color);
    border: 1px solid transparent
  }
}
</style>
